import React, {useState} from 'react'
import styles from 'components/Order/OrderDetails/HistoryTabs/HistoryTabs.module.css'
import UpdateStatusChangeDialog from 'components/Order/OrderDetails/HistoryTabs/UpdateStatusChangeDialog'
import {approveCargo, editStatusChange, rejectCargo} from 'services/OrderService'
import {ApproveRejectCargoDialog} from 'components/Order/OrderDetails/HistoryTabs/ApproveRejectCargoDialog'
import {ShowCargoDialog} from 'components/Order/OrderDetails/HistoryTabs/ShowCargoDialog'
import {HTTP_422_ERROR} from 'Constants'
import {INVALID_STATUS_CHANGE} from 'services/errorCodes'
import ApiError from 'constants/ApiError'
import {useErrorHandling} from 'context/errorHandling'
import {MailingHistory, OrderHistory} from 'components/Order/OrderDetails/HistoryTabs/Tabs'
import IndependentTabs from 'components/Shared/Tabs/IndependentTabs'
import {useTranslation} from 'react-i18next'

const ChangeError = {
  DateMustBeAfterPreviousStatusChange: 'notifications.error.editStatusChange.dateMustBeAfterPreviousStatusChangeError',
  DateMustBeBeforeNextStatusChange: 'notifications.error.editStatusChange.dateMustBeBeforeNextStatusChangeError',
  DateFromFuture: 'notifications.error.editStatusChange.dateFromFuture'
}

export default function HistoryTabs({
                                      order,
                                      actions,
                                      refreshActions,
                                      refreshStatuses,
                                      onStatusChanged,
                                      mailingHistoryList,
                                      disableEdit
                                    }) {
  const {handleError} = useErrorHandling()
  const {t} = useTranslation()

  const [editedStatusChange, setEditedStatusChange] = useState()
  const [statusChangeBeforeEdited, setStatusChangeBeforeEdited] = useState()
  const [selectedAction, setSelectedAction] = useState()
  const [showDeliveryPointStatusChange, setShowDeliveryPointStatusChange] = useState()

  const onActionEdit = newValues => {
    if (newValues) {
      editStatusChange(editedStatusChange.id, newValues)
        .then(() => {
          refreshActions()
        })
        .catch(error => {
            const errorCode = error?.response?.data?.errorCode
            return handleError(error, {
              [HTTP_422_ERROR]: errorCode === 'DATE_NOT_AFTER_PREVIOUS_STATUS_CHANGE' ?
                ChangeError.DateMustBeAfterPreviousStatusChange :
                errorCode === 'DATE_NOT_BEFORE_NEXT_STATUS_CHANGE' ?
                  ChangeError.DateMustBeBeforeNextStatusChange :
                  errorCode === 'DATE_FROM_FUTURE' ?
                    ChangeError.DateFromFuture : ApiError.UnprocessableEntity
            })
          }
        )
    }
    setEditedStatusChange(null)
  }

  const onDialogClose = () => {
    setSelectedAction(null)
  }

  const onCargoApproveAction = values => {
    if (values) {
      const approveParams = {
        ...values,
        emailSendRequested: true
      }
      approveCargo(selectedAction.id, approveParams)
        .then(() => {
          refreshActions()
        })
        .catch(error =>
          handleError(error, {
            [HTTP_422_ERROR]: error?.response?.data?.errorCode === INVALID_STATUS_CHANGE ?
              'notifications.error.invalidStatusChange' : ApiError.UnprocessableEntity
          })
        )
    }
    onDialogClose()
  }

  const onCargoRejectAction = rejected => {
    if (rejected) {
      rejectCargo(selectedAction.id)
        .then((response) => {
          refreshActions()
          refreshStatuses()
          onStatusChanged({
            status: response.status === 'LOADED' ? 'LOADING' : 'UNLOADING',
            deliveryPointNumber: response.deliveryPointPosition
          })
        })
        .catch(error =>
          handleError(error, {
            [HTTP_422_ERROR]: error?.response?.data?.errorCode === INVALID_STATUS_CHANGE ?
              'notifications.error.invalidStatusChange' : ApiError.UnprocessableEntity
          })
        )
    }
    onDialogClose()
  }

  function findOrderStatusChangePreviousActionIndex(startIndex) {
    for (let i = startIndex + 1; i < actions.length; i++) {
      if (actions[i].actionType === "ORDER_STATUS_CHANGE") {
        return i;
      }
    }
    return actions.length + 1;
  }

  return (
    <div className={styles.historyTabsWrapper}>
      {editedStatusChange && <UpdateStatusChangeDialog statusChange={editedStatusChange}
                                                       previousStatusChange={statusChangeBeforeEdited}
                                                       order={order}
                                                       onClose={onActionEdit}/>}
      {selectedAction && <ApproveRejectCargoDialog order={order}
                                                   action={selectedAction}
                                                   onClose={onDialogClose}
                                                   onApprove={onCargoApproveAction}
                                                   onReject={onCargoRejectAction}/>}

      {showDeliveryPointStatusChange && <ShowCargoDialog action={showDeliveryPointStatusChange}
                                                         onClose={() => setShowDeliveryPointStatusChange(null)}/>}
      <IndependentTabs
        tabs={[
          {
            label: t('order.details.history.actions.historyTitle'),
            render: () => <OrderHistory order={order}
                                        actions={actions}
                                        isEditable={!disableEdit}
                                        onOrderStatusChangeEdit={(statusChange, statusChangeIndex) => {
                                          setEditedStatusChange(statusChange)
                                          setStatusChangeBeforeEdited(actions[findOrderStatusChangePreviousActionIndex(statusChangeIndex)])
                                        }}
                                        onCargoApproveRejectClicked={setSelectedAction}
                                        onDeliveryPointCargoShow={setShowDeliveryPointStatusChange}/>
          },
          {
            label: t('order.details.history.emails.historyTitle'),
            render: () => <MailingHistory mailingHistory={mailingHistoryList}/>
          }
        ]}
      >
      </IndependentTabs>
    </div>
  )
}
